<template>
	<span class="v-badge">
		<slot/>
	</span>
</template>

<style lang="scss" src="./VBadge.scss"/>

<script lang="ts">
/**
 * VBadge — короткая метка-бейдж.
 *
 * Темы задаются классом: default, primary, warning, success.
 * Без класса — обводка accent цветом без заливки.
 *
 * @example
 *   <VBadge>Образцы</VBadge>
 *   <VBadge class="primary">Прямой</VBadge>
 *   <VBadge class="warning">Удалён</VBadge>
 *   <VBadge class="success">Оплачен</VBadge>
 *
 * Несколько бейджей подряд группируйте в локальной flex-обёртке —
 * базового контейнера компонент не предоставляет (YAGNI).
 */
export default defineComponent({
	name: 'VBadge',
});
</script>